<template>
  <p class="heading-xxs">
    <span v-if="regularPrice" class="line-through me-8">
      {{ regularPrice }}
    </span>
    {{ price }} {{ unit }}
  </p>
</template>

<script lang="ts" setup>
interface Props {
  price: string;
  regularPrice?: string;
  unit?: string;
}

withDefaults(defineProps<Props>(), {
  regularPrice: '',
  unit: 'kr/mån',
});
</script>
